import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import { LoadingScreen } from "../../../../wallets/shared/LoadingScreen.js";
const BuyScreen = lazy(() => import("./BuyScreen.js"));
export function LazyBuyScreen(props) {
    return (_jsx(Suspense, { fallback: _jsx(LoadingScreen, {}), children: _jsx(BuyScreen, { ...props }) }));
}
//# sourceMappingURL=LazyBuyScreen.js.map